<template>
  <div class="subscribe">
    <div class="row justify-content-md-center" v-if="$route.params.paypal === 'annulation'" style="margin-top:10px;">
      <div class="col-lg-6 col-12 text-center">
        <b-alert variant="danger" show >
          <h4 class="alert-heading">Une erreur s'est produite !</h4>
          Merci de renouveler votre demande ultérieurement
        </b-alert>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="$route.params.paypal === 'validation'" style="margin-top:10px;">
      <div class="col-lg-6 col-12  text-center">
        <b-alert show variant="success">
          <h4 class="alert-heading">Paiement validé !</h4>
          <p>
            Votre abonnement à bien été pris en compte.<br/>
            Vous allez recevoir d'ici quelques instants un mail de confirmation.
          </p>
          <hr>
          <p class="mb-0">
            Suite à la réception du mail de confirmation, vous pourrez accéder à votre <a href="/pronostics" >espace VIP</a>.
          </p>
        </b-alert>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="!$route.params.paypal && auth.user" style="margin-top:10px;">
      <div class="col-lg-6 col-12 text-center">
        <b-alert variant="danger" v-if="auth.user.subscription.active" show>
          <h4 class="alert-heading">Vous disposez déjà d'un abonnement VIP</h4>
          <a href="/pronostics" >Accéder à mon espace VIP</a>
        </b-alert>
        <b-alert variant="danger" v-else-if="auth.user.subscribed" show>
          <h4 class="alert-heading">Votre abonnement expire bientôt</h4>
          Sélectionnez l'une de nos offres pour le renouveler
        </b-alert>
        <b-alert variant="danger" v-else-if="auth.user.subscription.expires_at > 0" show>
          <h4 class="alert-heading">Votre abonnement a expiré</h4>
          Souscrivez à l'un des abonnements suivants pour accéder à votre espace VIP<br/>
          <hr>
          Si vous venez de souscrire un abonnement, merci de réessayer d'ici quelques instants
        </b-alert>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="!$route.params.paypal || $route.params.paypal !== 'validation'" style="margin-top:10px;">
      <div class="col-12 text-center">
        <h1>Nos offres VIP</h1>
        <form :action="paypal.url" method="post" ref="monthly" v-if="auth.user">
          <input type="hidden" name="custom" :value="auth.user.uid">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="paypal.subscribe_id">
          <input type="hidden" name="on0" value="">
          <input type="hidden" name="os0" value="MENSUEL">
          <input type="hidden" name="currency_code" value="EUR">
          <input type="hidden" name="lc" value="fr_FR">
        </form>
        <form :action="paypal.url" method="post" ref="yearly" v-if="auth.user">
          <input type="hidden" name="custom" :value="auth.user.uid">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="paypal.subscribe_id">
          <input type="hidden" name="on0" value="">
          <input type="hidden" name="os0" value="ANNUEL">
          <input type="hidden" name="currency_code" value="EUR">
          <input type="hidden" name="lc" value="fr_FR">
        </form>
        <form :action="paypal.url" method="post" ref="one_month" v-if="auth.user">
          <input type="hidden" name="custom" :value="auth.user.uid">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" :value="paypal.buy_id">
          <input type="hidden" name="on0" value="">
          <input type="hidden" name="os0" value="MENSUEL">
          <input type="hidden" name="currency_code" value="EUR">
          <input type="hidden" name="lc" value="fr_FR">
        </form>
        <form :action="paypal.url" method="post" ref="discount" v-if="auth.user">
          <input type="hidden" name="custom" :value="auth.user.uid">
          <input type="hidden" name="cmd" value="_xclick">
          <input type="hidden" name="business" :value="paypal.email">
          <input type="hidden" name="item_name" :value="discount.description">
          <input type="hidden" name="amount" :value="discount.price">
          <input type="hidden" name="no_shipping" value="1">
          <input type="hidden" name="button_subtype" value="services">
          <input type="hidden" name="on0" value="">
          <input type="hidden" name="os0" value="MENSUEL">
          <input type="hidden" name="currency_code" value="EUR">
          <input type="hidden" name="lc" value="fr_FR">
          <input type="hidden" name="return" value="https://www.cklmpronos.fr/abonnement/validation">
          <input type="hidden" name="cancel_return" value="https://www.cklmpronos.fr/abonnement/annulation">
        </form>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="!$route.params.paypal || $route.params.paypal !== 'validation'" style="margin-top:10px;">
      <div class="col-lg-3 col-12">
        <b-card
          title="Abonnement mensuel"
          footer-tag="footer"
          img-top
          tag="article"
          class="mb-2"
          bg-variant="dark"
          text-variant="white"
          @click="submitMontlhy"
        >
          <b-card-text class="text-center">
            <p class="card-text">
              <span class="text-warning" style="font-size: 5em;">9,99€</span>
              <span>/mois</span><br/>
              <span>1er mois à 4,99€</span>
            </p>
            
            <div>
              <input type="image" class="button" src="/img/btn_subscribeCC_LG.gif" border="0" name="submit" alt="Payer avec paypal">
              <img alt="" border="0" src="/img/pixel.gif" width="1" height="1">
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-lg-3 col-12">
        <b-card
          title="Abonnement annuel"
          footer-tag="footer"
          img-top
          tag="article"
          class="mb-2"
          bg-variant="dark"
          text-variant="white"
          @click="submitYearly"
        >
          <b-card-text class="text-center">
            <p class="card-text">
              <span class="text-warning" style="font-size: 5em;">49,99€</span>
              <span>/an</span><br/>
              <span>1er mois à 4,99€</span>
            </p>
            <div>
              <input type="image" class="button" src="/img/btn_subscribeCC_LG.gif" border="0" name="submit" alt="Payer avec paypal">
              <img alt="" border="0" src="/img/pixel.gif" width="1" height="1">
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-lg-3 col-12" v-if="!discountActive">
        <b-card
          title="A l'unité"
          footer-tag="footer"
          img-top
          tag="article"
          class="mb-2"
          bg-variant="dark"
          text-variant="white"
          @click="submitOneMonth"
        >
          <b-card-text class="text-center">
            <p class="card-text">
              <span class="text-warning" style="font-size: 5em;">9,99€</span>
              <span></span><br/>
              <span>Pour 1 mois d'accès VIP</span>
            </p>
            
            <div>
              <input type="image" class="button" src="/img/btn_buynowCC_LG.gif" border="0" name="submit" alt="Payer avec paypal">
              <img alt="" border="0" src="/img/pixel.gif" width="1" height="1">
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-lg-3 col-12" v-if="discountActive">
        <b-card
          :title="discount.title"
          footer-tag="footer"
          img-top
          tag="article"
          class="mb-2"
          bg-variant="dark"
          text-variant="white"
          @click="submitDiscount"
        >
          <b-card-text class="text-center">
            <p class="card-text">
              <span class="text-warning" style="font-size: 5em;">{{(discount.price+"").replace('.',',')}}€</span>
              <span></span><br/>
              <span>{{discount.description}}</span><br/>
              <span>Se termine {{discountRemaining}}</span>
            </p>
            
            <div>
              <input type="image" class="button" src="/img/btn_buynowCC_LG.gif" border="0" name="submit" alt="Payer avec paypal">
              <img alt="" border="0" src="/img/pixel.gif" width="1" height="1">
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/firebase.js'
import paypal from '@/paypal.js'
import { db } from '@/firebase.js'
import moment from 'moment'

export default {
  props: ['type'],
  data: () => ({ auth: auth, paypal: paypal, discount: null, periodicity: null }),
  methods : {
    submitMontlhy : function(){
      if(auth.user) {
        if(auth.user.subscription.active) {
          alert("Vous disposez déjà d'un abonnement VIP")
        } else {
          this.$refs.monthly.submit()
        }
      } else {
        this.$router.replace('/creation-compte?redirect=/abonnement')
      }
    },
    submitYearly : function(){
      if(auth.user) {
        if(auth.user.subscription.active) {
          alert("Vous disposez déjà d'un abonnement VIP")
        } else {
          this.$refs.yearly.submit()
        }
      } else {
        this.$router.replace('/creation-compte?redirect=/abonnement')
      }
    },
    submitOneMonth : function(){
      if(auth.user) {
        this.$refs.one_month.submit()
      } else {
        this.$router.replace('/creation-compte?redirect=/abonnement')
      }
    },
    submitDiscount : function(){
      if(auth.user) {
        this.$refs.discount.submit()
      } else {
        this.$router.replace('/creation-compte?redirect=/abonnement')
      }
    }
  },
  computed: {
    discountActive: function () {
      return this.discount && this.discount.end > moment().unix();
    },
    discountRemaining: function() {
      return moment().to(moment.unix(this.discount.end));
    }
  },
  firestore: {
    discount: db.collection('settings').doc('discount'),
  }
}
</script>

<style>
.button {
  cursor: pointer;
}
</style>